import axios from "axios";
import { getTokenHeader } from "../../../helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "Features",
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    global: false,
    featureGroups: [],
    billingTypes: [
      { name: "Jährlich", value: "yearly" },
      { name: "Monatlich", value: "monthly" }
    ],
    vatTypes: [
      { name: "Inklusive", value: "inclusive" },
      { name: "Exklusive", value: "exclusive" },
      { name: "Keine", value: "none" }
    ],
    newFeatureGroupTitle: "",
    editedItem: {}
  }),
  async mounted() {
    await this.getFeatureGroups();
  },
  computed: {
    selectedFeatureGroups() {
      return this.featureGroups
        .filter(fg => fg.principals.includes(this.currentPrincipal))
        .map(fg => fg._id);
    },

    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    clientUrl() {
      return env.locations_api_client_url;
    }
  },
  methods: {
    async getFeatureGroups() {
      try {
        const headers = getTokenHeader();
        const response = await axios.get(
          `${this.clientUrl}feature-groups?principal=${this.currentPrincipal}`,
          { headers }
        );
        this.featureGroups = response.data;
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
      }
    },

    async addFeatureGroup() {
      if (!this.newFeatureGroupTitle) return;

      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${this.clientUrl}feature-groups`,
          {
            name: this.newFeatureGroupTitle,
            principals: [this.currentPrincipal],
            owner: this.currentPrincipal
          },
          { headers }
        );
        if (response.status !== 201) {
          throw new Error("Failed to create feature group");
        }
        await this.getFeatureGroups();
        this.newFeatureGroupTitle = "";
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
        await this.getFeatureGroups();
      }
    },
    async addNewFeature(featureGroupId) {
      this.editedItem = {
        featureGroup: featureGroupId,
        priceOne: 0,
        priceTwo: 0,
        priceThree: 0,
        priceFour: 0,
        priceFive: 0,
        priceSix: 0,
        priceSeven: 0,
        priceEight: 0,
        priceNine: 0,
        priceTen: 0,
        description: "",
        vatType: "",
        billingType: ""
      };
    },
    async createFeature() {
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${this.clientUrl}features`,
          {
            name: this.editedItem.title,
            priceOne: this.editedItem.priceOne,
            priceTwo: this.editedItem.priceTwo,
            priceThree: this.editedItem.priceThree,
            priceFour: this.editedItem.priceFour,
            priceFive: this.editedItem.priceFive,
            priceSix: this.editedItem.priceSix,
            priceSeven: this.editedItem.priceSeven,
            priceEight: this.editedItem.priceEight,
            priceNine: this.editedItem.priceNine,
            priceTen: this.editedItem.priceTen,
            description: this.editedItem.description,
            vatType: this.editedItem.vatType,
            billingType: this.editedItem.billingType,
            featureGroup: this.editedItem.featureGroup
          },
          { headers }
        );
        if (response.status !== 201) {
          throw new Error("Failed to create feature");
        }
        await this.getFeatureGroups();
        this.editedItem = {};
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
        await this.getFeatureGroups();
      }
    },
    async deleteFeatureGroup(featureGroupId) {
      const confirm = await this.$confirm(
        "Möchten Sie Merkmalsgruppe wirklich löschen?",
        confirmWarningConfig
      );

      if (confirm) {
        try {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${this.clientUrl}feature-groups/${featureGroupId}`,
            { headers }
          );
          if (response.status !== 204) {
            throw new Error("Failed to delete feature group");
          }
          await this.getFeatureGroups();
        } catch (e) {
          console.error(e);
          this.$store.dispatch("createError");
          await this.getFeatureGroups();
        }
      }
    },
    editFeature(feature, featureGroupId) {
      this.editedItem = { ...feature, featureGroupId };
    },
    async deleteFeature(featureId) {
      const confirm = await this.$confirm(
        "Möchten Sie dieses Merkmal wirklich löschen?",
        confirmWarningConfig
      );

      if (confirm) {
        try {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${this.clientUrl}features/${featureId}`,
            { headers }
          );
          if (response.status !== 204) {
            throw new Error("Failed to delete feature");
          }
          await this.getFeatureGroups();
        } catch (e) {
          console.error(e);
          this.$store.dispatch("createError");
          await this.getFeatureGroups();
        }
      }
    },
    async updateSubscribedFeatureGroups(val) {
      const featureGroupsToBeRemoved = this.featureGroups.filter(
        fg =>
          fg.principals.includes(this.currentPrincipal) && !val.includes(fg._id)
      );
      const featureGroupsToBeAdded = this.featureGroups.filter(
        fg =>
          !fg.principals.includes(this.currentPrincipal) && val.includes(fg._id)
      );
      try {
        const headers = getTokenHeader();

        for (const fg of featureGroupsToBeRemoved) {
          const updatedPrincipals = fg.principals.filter(
            p => p !== this.currentPrincipal
          );
          const response = await axios.put(
            `${this.clientUrl}feature-groups/${fg._id}`,
            {
              principals: updatedPrincipals
            },
            { headers }
          );
          if (response.status !== 200) {
            throw new Error("Failed to update feature group");
          }
        }

        for (const fg of featureGroupsToBeAdded) {
          const updatedPrincipals = [...fg.principals, this.currentPrincipal];
          const response = await axios.put(
            `${this.clientUrl}feature-groups/${fg._id}`,
            {
              principals: updatedPrincipals
            },
            { headers }
          );
          if (response.status !== 200) {
            throw new Error("Failed to update feature group");
          }
        }
        await this.getFeatureGroups();
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
        await this.getFeatureGroups();
      }
    },
    async saveFeature() {
      try {
        const headers = getTokenHeader();

        if (!this.editedItem._id) {
          await this.createFeature();
        } else {
          const response = await axios.put(
            `${this.clientUrl}features/${this.editedItem._id}`,
            {
              name: this.editedItem.title,
              priceOne: this.editedItem.priceOne,
              priceTwo: this.editedItem.priceTwo,
              priceThree: this.editedItem.priceThree,
              priceFour: this.editedItem.priceFour,
              priceFive: this.editedItem.priceFive,
              priceSix: this.editedItem.priceSix,
              priceSeven: this.editedItem.priceSeven,
              priceEight: this.editedItem.priceEight,
              priceNine: this.editedItem.priceNine,
              priceTen: this.editedItem.priceTen,
              description: this.editedItem.description,
              vatType: this.editedItem.vatType,
              billingType: this.editedItem.billingType
            },
            { headers }
          );
          if (response.status !== 200) {
            throw new Error("Failed to update feature");
          }
          await this.getFeatureGroups();
          this.editedItem = {};
        }
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
        await this.getFeatureGroups();
      }
    }
  }
};
